import WithPermissionRestricted from '../../../../../../general/hoc/WithPermissionRestricted'
import { PaymentSchemesDashboardProvider } from './PaymentSchemesDashboard'
import PaymentSchemesDashboardLayout from './PaymentSchemesDashboardLayout'

function PaymentSchemesDashboardWrapper() {

    return (
        <PaymentSchemesDashboardProvider>
            <PaymentSchemesDashboardLayout />
        </PaymentSchemesDashboardProvider>
    )
}

export default WithPermissionRestricted(PaymentSchemesDashboardWrapper, 'FILTERS', [
    'payments',
    'GetAllPayments',
])
